import { Form, FormGroup } from 'react-bootstrap';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

function ProfileInfoComponent(props) {
  const leftColumnPositions = [];
  const rightColumnPositions = [];
  const otherBoxTouched = useRef(false);

  const handleProfileCategoriesChange = (e) => {
    otherBoxTouched.current = false;
    if (e.target.checked) {
      props.setProfileCategories((result) => [
        ...result,
        parseInt(e.target.id.split('category_')[1])
      ]);
    } else {
      props.setProfileCategories(
        props.profileData?.filter(function (category) {
          return category != e.target.id.split('category_')[1];
        })
      );
    }
  };

  let i = 0;
  do {
    if (props.categoryData[i].categoryOption != 'Other') {
      leftColumnPositions.push(
        <Form.Check
          type="checkbox"
          id={props.title.replace(/\/|\s/g, '') + 'category_' + props.categoryData[i].categoryId}
          key={props.title.replace(/\/|\s/g, '') + 'category' + props.categoryData[i].categoryId}
          checked={props.profileData?.find((c) => c == props.categoryData[i].categoryId)}
          onChange={handleProfileCategoriesChange}
          style={{ marginBottom: '20px', fontSize: '14px', fontWeight: '400' }}
          className='text-color profileInfo-checkbox'
          label={props.categoryData[i].categoryOption}
        />
      );
    }
    i++;
  } while (leftColumnPositions.length < props.categoryData.length / 2);

  do {
    if (props.categoryData[i]?.categoryOption != 'Other') {
      rightColumnPositions.push(
        <Form.Check
          type="checkbox"
          id={props.title.replace(/\/|\s/g, '') + 'category_' + props.categoryData[i].categoryId}
          key={props.title.replace(/\/|\s/g, '') + 'category' + props.categoryData[i].categoryId}
          checked={props.profileData?.find((c) => c == props.categoryData[i].categoryId)}
          onChange={handleProfileCategoriesChange}
          style={{ marginBottom: '20px', fontSize: '14px', fontWeight: '400' }}
          className='text-color profileInfo-checkbox'
          label={props.categoryData[i].categoryOption}
        />
      );
    }
    i++;
  } while (i < props.categoryData.length);

  if (props.categoryData.find((c) => c.categoryOption === 'Other')) {
    var otherOption = props.categoryData.find((c) => c.categoryOption === 'Other');
    rightColumnPositions.push(
      <div>
        <Form.Check
          id={props.title.replace(/\/|\s/g, '') + 'category_' + otherOption.categoryId}
          style={{ marginBottom: '10px', fontSize: '14px', fontWeight: '400' }}
          className='text-color profileInfo-checkbox'
          type="checkbox"
          key = {props.title.replace(/\/|\s/g, '') + 'category_' + otherOption.categoryId}
          checked={props.profileData?.find((c) => c == otherOption.categoryId)}
          onChange={handleProfileCategoriesChange}
          label={otherOption.categoryOption}
        />
        {props.profileData?.includes(otherOption.categoryId) && (
          <FormGroup>
            <Form.Control
              id={props.title.replace(/\/|\s/g, '') + 'TextBoxCategory_' + otherOption.categoryId}
              key={props.title.replace(/\/|\s/g, '') + 'TextBoxCategory_' + otherOption.categoryId}
              type="text"
              defaultValue={props.otherOptionValue}
              onBlur={(e) => {
                props.setOtherValue(e.target.value);
                otherBoxTouched.current = true;
              }}
              isInvalid={otherBoxTouched.current && !props.otherOptionValue}
              required
              className={props.isMyProfilePage ? 'myProfile-textbox' : ''}
            />
            <Form.Control.Feedback type="invalid">
              Please provide a category name
            </Form.Control.Feedback>
          </FormGroup>
        )}
      </div>
    );
  }

  return (
    <>
      <p style={{ fontSize: '15px', fontWeight: '600' }}>{props.title}</p>

      <div className="d-flex flex-row">
        <div className="d-flex flex-column w-100">{leftColumnPositions}</div>
        <div className="d-flex flex-column w-100">{rightColumnPositions}</div>
      </div>
    </>
  );
}

ProfileInfoComponent.propTypes = {
  title: PropTypes.string,
  categoryData: PropTypes.array,
  profileData: PropTypes.array,
  setProfileCategories: PropTypes.func,
  otherOptionValue: PropTypes.string,
  setOtherValue: PropTypes.func,
  isMyProfilePage: PropTypes.bool
};

export default ProfileInfoComponent;
